'use strict';

import React from 'react';
import FavouritesMenuIconComponent from './../components/FavouritesMenuIconComponent';

class FavouritesMenuIcon extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return(
      <FavouritesMenuIconComponent />
    )
  }
}

export default FavouritesMenuIcon;
